<template>
    <div
        :class="classSpacer"
        class="spacer"
    ></div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
    size: 'EXTRA_LARGE' | 'LARGE' | 'MEDIUM' | 'SMALL'
}>()

const classSpacer = computed(() =>
    props.size.toLocaleLowerCase().replace('_', '-')
)
</script>

<style lang="scss" scoped>
.spacer {
    width: 100%;
    display: block;

    &.small {
        height: 20px;
    }

    &.medium {
        height: 40px;
    }

    &.large {
        height: 60px;
    }

    &.extra-large {
        height: 80px;
    }
}
</style>
